import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/data.service';

@Component({
  selector: 'app-penzugy-layout',
  templateUrl: './penzugy-layout.component.html',
  styleUrls: ['./penzugy-layout.component.scss'],
})
export class AdougyLayoutComponent  implements OnInit {


  menu=0
  urlmatrix=[{},{},{url:"adofolyoszamla"}
    //{},{url:"adatszolg"},{url:"szamla"},{url:"beszerzes"},{url:"statisztika"},{url:"egyenleg"},{url:"ertekesit"}
  ]

  sajatIntezmeny
  htmlContent: string = '';
  egyenleg
  loginmode

  constructor(private data:DataService,private router: Router) { }

  async ngOnInit() {
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))
    // Az egyenleg objektumként van a tárolóban: a régi JSON.parse kivételt dobott,
    // és az ngOnInit itt megszakadt (a loginmode sem töltődött be utána).
    const nyersEgyenleg = await this.data.getFromStorage("egyenleg");
    try { this.egyenleg = typeof nyersEgyenleg === "string" ? JSON.parse(nyersEgyenleg) : (nyersEgyenleg || null); }
    catch { this.egyenleg = null; }
    this.loginmode = (await this.data.getFromStorage("loginmode"))
    //window.location.replace("/admin/importallomany")
    //this.import=4
    //this.menuChange(4)
    //if(window.location.pathname.indexOf("admin/import") != -1)
    
    //console.log(this.sajatIntezmeny)
  }

  openComponent(c){

  }

  menuChange(n){
    this.menu=n

 
  //window.history.replaceState({}, '', "/admin/"+this.urlmatrix[n][x].url)
  this.router.navigateByUrl("/konyveles/"+this.urlmatrix[n].url);
  //console.log(this.urlmatrix[n][x].url)
  

  
  }

}
